import { IconInfoCircle } from '@tabler/icons-react';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Icon } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { AllowanceBasedTooltip } from '../AllowanceTooltip/AllowanceBasedTooltip';

type Props = {
  onboardingPeriodId: string;
};

export const EnrollmentReviewAllowanceTooltip = ({
  onboardingPeriodId,
}: Props) => {
  const { data: possibleEmployerContribution = [] } = useMonolithQuery({
    method:
      'contributionModelsControllerFindPossibleEmployerContributionsByAnyPeriod',
    params: [onboardingPeriodId],
  });

  return (
    <Tooltip
      label={
        <AllowanceBasedTooltip
          possibleEmployerContributions={possibleEmployerContribution}
        />
      }
    >
      <Icon style={{ cursor: 'pointer' }} icon={IconInfoCircle} size="1rem" />
    </Tooltip>
  );
};
